export default __webpack_public_path__ + "static/user-experience-phone-f424a33c99b6b28769ff74bdfbf1625f.png";